import type { ReactNode } from "react"

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { cn } from "@/lib/utils"

/**
 * design-system.md's `FormCard`: a titled form section container — a `Card`
 * with no external margin and `background=muted/30` (matching the view-mode
 * document card's own background), a `CardHeader` containing only a
 * `CardTitle` (no description), and a `CardContent` holding arbitrary form
 * fields. `title` accepts a `ReactNode` so a card-level mandatory
 * requirement (document-editor.md's Невідповідності card) can prepend the
 * shared destructive asterisk without a second heading treatment.
 *
 * **Background history:** originally a bug — hardcoded `bg-sidebar`, which
 * only looked like a plausible light tint while `--sidebar` itself happened
 * to be one; broke once `--sidebar` became a deliberately dark color. Fixed
 * to `bg-muted/30` per design-system.md's documented resolution.
 */
export function FormCard({
  title,
  children,
  className,
}: {
  title?: ReactNode
  children: ReactNode
  className?: string
}) {
  return (
    <Card className={cn("@container bg-muted/30", className)}>
      {title && (
        <CardHeader>
          <CardTitle>{title}</CardTitle>
        </CardHeader>
      )}
      <CardContent>{children}</CardContent>
    </Card>
  )
}
